import React from 'react';
import PropTypes from 'prop-types';

function TestResultCard({ result, getStatusColor, getStatusIcon }) {
  return (
    <div className={`result-card ${getStatusColor(result.status)}`}>
      <div className="result-header">
        <span className="result-name">{result.name}</span>
        <span className={`status-badge ${result.status}`}>
          {getStatusIcon(result.status)}
        </span>
      </div>
      
      <div className="result-value">
        <span className="value-text">{result.value}</span>
        {result.range && (
          <span className="range-text">{result.range}</span>
        )}
      </div>
      
      {result.explanation && (
        <div className="result-explanation">
          {result.explanation}
        </div>
      )}
    </div>
  );
}

TestResultCard.propTypes = {
  result: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    range: PropTypes.string,
    status: PropTypes.string.isRequired,
    explanation: PropTypes.string,
  }).isRequired,
  getStatusColor: PropTypes.func.isRequired,
  getStatusIcon: PropTypes.func.isRequired,
};

export default TestResultCard;